<section>
  <article>
    <div class="containert-fz-btn">
      <a href="/explore">
        <button mat-raised-button class="btn-fz">{{'actions.schedule' | translate}}</button>
      </a>
    </div>
  </article>
</section>
